/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from "axios";
import useApi from "../api";
import { IApiResponse } from "../interfaces/IApiResponse";
import { useFormatMessage } from "../../utils/useFormatMessage";
import { IStore } from "../../utils/interfaces/IStore";
import { IStoreByUser } from "./interfaces/IStoreByUser";

export const useStoreService = () => {
  const api = useApi();
  const { errorMessage } = useFormatMessage();
  async function getAllStore(): Promise<IApiResponse<any>> {
    try {
      const login = localStorage.getItem('Login')
      const response = await api.get(`/Store/getAll/${login}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getStoreById(id: number): Promise<IApiResponse<any>> {
    try {
      const response = await api.get(`/Store/getById/${id}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function createStore(data: IStore): Promise<IApiResponse<IStore[] | any>> {
    try {
      const response = await api.post(`/Store/create`, data);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function updateStore(data: IStore): Promise<IApiResponse<IStore[] | any>> {
    try {
      const response = await api.post(`/Store/Update`, data);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  
  async function getAllUsersRelated(id: number): Promise<IApiResponse<any>> {
    try {
      const response = await api.get(`/Store/GetAllUsersRelated/${id}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function updateUsersByStore(data: IStoreByUser): Promise<IApiResponse<IStoreByUser[] | any>> {
    try {
      const response = await api.post(`/Store/UpdateUsersByStoreAsync`, data);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  return {
    getAllStore,
    getStoreById,
    createStore,
    updateStore,
    getAllUsersRelated,
    updateUsersByStore
  };
};
